import { Typography } from '@sede-enterprise/shell-ds-fabrics';
import {
  Flexbox,
  NavBar,
  Popover,
} from '@sede-enterprise/shell-ds-react-framework';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import {
  SPACING_0,
  SPACING_1,
  SPACING_2,
  SPACING_3,
} from 'constants/theme-constants';
import { AppThemeType } from 'store/types';
import styled from 'styled-components';

export const HeaderTextWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    justify-content: center;
  `}
`;
export const HeaderSubText = styled.span`
  ${({ theme }) => `
    ${Typography.label.extraSmall.bold};
    color: #757575;
    text-align: left;
  `}
`;

export const HeaderText = styled.span`
  ${({ theme }) => `
    ${Typography.paragraph.small.bold};
    color: ${theme.text.onSurface.strong};
  `}
`;

export const TabsContainer = styled.div<{ disabled?: boolean }>`
  height: 100%;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;

export const ProfileButton = styled.button`
  ${({ theme }) => `
    display: flex;
    gap: ${cxTheme.spacing[SPACING_1]};
    width: 100%;
    align-items: center;
    min-width: 212px;
    color: ${theme.text.onSurface.strong};
    ${Typography.paragraph.small.normal};
    padding: 9px ${cxTheme.spacing[SPACING_3]};
    border: none;
    transition: background-color 0.3s ease-out;
    background-color: transparent;
    
    &:hover {
      cursor: pointer;
      background-color: rgba(0, 151, 168, 0.10);
    }

    @media screen and (max-width: ${cxTheme.breakpoints.desktop}px) {
      padding: 12px ${cxTheme.spacing[4]};
      gap: ${cxTheme.spacing[SPACING_2]};

      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
  `}
`;

export const ProfilePopupWrapper = styled.div`
  ${({ theme }) => `
    background-color: ${theme.onSurface.surface.default.background};
    border-radius: ${cxTheme.spacing[SPACING_0]};
    position: relative;
    overflow: hidden;
  `}
`;

export const ShellNavWrapper = styled.div`
  ${({ theme }) => `
    .shell-button {
      border-color: ${theme.border.medium};

      &:hover {
        border-color: ${theme.border.strong};
      }
    }
    
    .shell-menu-horizontal .shell-menu-item.shell-menu-item-selected {
      background-color: transparent;
    }
    
    .shell-menu-item.shell-menu-item-active, .shell-menu-item.shell-menu-item-active.shell-menu-item-selected {
      border-color: ${theme.onSurface.surface.default.border.strong};
      color: ${theme.text.onBase.strong};
    }
    
    .shell-menu-item.shell-menu-item-active:not(.shell-menu-item-selected) .shell-menu-label{
      background-color: unset;
    }
    
    .shell-menu-item:not(.shell-menu-item-selected) .shell-menu-label svg {
      fill: ${theme.text.onSurface.subtle}
    }
  
  `}
`;

export const ShellNavBar = styled(NavBar)`
  &.shell-nav-bar {
    z-index: 4;
  }
`;

export const ShellPopover = styled(Popover)`
  &.shell-popover {
    z-index: 31;
  }
`;

export const CompanyLandingUnderNavHeader = styled(Flexbox)<{
  $appTheme: AppThemeType;
}>`
  ${({ theme, $appTheme }) => `
    padding: 28px 40px;
    justify-content: space-between;
    background-color: ${$appTheme === 'light' ? 'white' : theme.background.surface};
    z-index: 3;
    width: 100%;
    height: 88px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    box-shadow: ${theme.elevation.level0};
  `}
`;

export const CompanyLandingUnderNavSkeletonWrappers = styled.div`
  display: flex;
  box-sizing: border-box;
  gap: 8px;
  flex-direction: column;
`;
